module.exports = __webpack_public_path__ + "img/vehicle-creation-options.72be4db3.svg";